var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"announcement-item"},[_c('wysiwyg-viewer',{staticClass:"announcement-item__content",attrs:{"value":_vm.announcement.text}}),_c('div',{staticClass:"announcement-item__time"},[_vm._v(_vm._s(_vm.time))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }